import React from "react";
import { toast } from "react-toastify";
import { Alert, Button } from "reactstrap";
import { callApi } from "../../api";
import CommonModal from "../../components/CommonModal";
import KEYS_AND_URLS from "../../constants/keys";

export const isPathPubliclyAccessible = (pathname) =>
  pathname.includes("/public/share") ||
  pathname.includes(`/${KEYS_AND_URLS.REGISTER_USER_URL}`) ||
  pathname.includes(KEYS_AND_URLS.ADMIN_PREVIEW_URL);

export const pathDoesNotRequireBusinessId = (pathname) =>
  pathname.includes("login") ||
  pathname.includes("error") ||
  pathname.includes("not-authorized") ||
  pathname.includes(KEYS_AND_URLS.ADMIN_PREVIEW_URL) ||
  pathname.includes(KEYS_AND_URLS.PAYMENT_METHOD_URL) ||
  pathname.includes(KEYS_AND_URLS.GET_USER);

export const getBIDFromURL = (url) => {
  const regToGetBID = /^(?:\/)([0-9])+(?:\/)/g;
  const matcher = url.match(regToGetBID);
  const bidBetweenSlashes = matcher ? matcher[0] : null;
  const bizID = bidBetweenSlashes?.slice(1, -1);
  return bizID ? parseInt(bizID, 10) : null;
};

export const getAuthStateFromCache = () => {
  const userFromLocalStorage = localStorage.getItem("user");
  const parsedUser = userFromLocalStorage
    ? JSON.parse(userFromLocalStorage)
    : null;
  const selectedBusinessFromLocalStorage =
    localStorage.getItem("selectedBusiness");
  const parsedSelectedBusiness =
    selectedBusinessFromLocalStorage &&
    selectedBusinessFromLocalStorage !== "undefined"
      ? JSON.parse(selectedBusinessFromLocalStorage)
      : null;
  const business = JSON.parse(localStorage.getItem("business"));
  return {
    user: parsedUser,
    selectedBusiness: parsedSelectedBusiness,
    business,
  };
};

export const addUpdateCache = (obj) => {
  Object.keys(obj).forEach((key) => {
    localStorage.setItem(key, obj[key]);
  });
};

export const removeFromCache = (arr) => {
  arr.forEach((key) => {
    localStorage.removeItem(key);
  });
};

export const getDataForAdmin = async () => {
  const adminBizResponse = await callApi("/protected/admin/businesses");
  if (adminBizResponse && adminBizResponse.status === true) {
    // addUpdateCache({
    //   business: JSON.stringify(adminBizResponse.data.businesses),
    // });

    return {
      users: adminBizResponse.data.users,
      businesses: adminBizResponse.data.businesses?.sort((a, b) =>
        (a.name || "").localeCompare(b.name)
      ),
    };
  }
  toast.error(adminBizResponse?.message);
  return {};
};

export const getBIDFromCachedRedirectURL = () => {
  const redirectURL = localStorage.getItem("redirectURL");
  const parsed = redirectURL ? JSON.parse(redirectURL) : null;
  const bizID = parsed ? parsed.bizID : null;
  if (bizID && bizID !== "undefined") {
    return parseInt(bizID, 10);
  }
  return null;
};

export const BusinessNotPermitted = ({ open, onStay, onSwitch }) => (
  <CommonModal
    modal={open}
    setModal={() => {}}
    title="No Business Permission"
    center
    noClose
  >
    <Alert color="danger" className="p-2">
      <div className="alert-body text-center">
        You do not have permission to access this busines information.
      </div>
      <div className="button-group d-flex justify-content-center align-item-center align-center">
        <Button color="secondary" className="mr-2" onClick={onStay}>
          Stay in current business
        </Button>
        <Button color="primary" onClick={onSwitch}>
          Switch Account
        </Button>
      </div>
    </Alert>
  </CommonModal>
);
